import photo from '../images/ProfilePhoto.JPG';
import "./Hero.css";
const Hero = () => {
  return (
    <section className='hero' id='home'>
      <div className='hero-left'>
        <h1>Hi, I'm Vishaal</h1>
        <h2>ASPIRING SOFTWARE DEVELOPER</h2>
        <p>
          B.Tech IT student building real systems with clean code — from full-stack applications to machine learning.
        </p>
        <div className='hero-buttons'>
          <a href='#projects'>
            <button>View Projects</button>
          </a>
          <a href="/Resume.pdf" target="_blank" rel = "noreferrer">
            <button>Resume</button>
          </a>
        </div>
        
      </div>

      <div className='hero-right'>
        <img
          src={photo}
          alt="profilephoto"
        />
      </div>
    </section>
  );
};

export default Hero;